export const CONTACT = {
  email: "contactus@trekpanda.in",
  phoneDisplay: "+91 95297 17726",
  phoneHref: "tel:+919529717726",
  whatsapp: "https://wa.me/919529717726?text=Hi%20TrekPanda!%20I'm%20interested%20in%20the%20Bhutan%20group%20trip.",
  website: "https://www.trekpanda.in",
};

export const MARQUEE_ITEMS = [
  "Tiger's Nest at dawn",
  "Thimphu's quiet streets",
  "108 chortens at Dochula",
  "Punakha Dzong by the river",
  "Gross National Happiness",
  "Butter tea & mountain air",
];

export const DAYS = [
  {
    n: "01",
    title: "Bagdogra to Phuentsholing",
    kicker: "Entering the Kingdom",
    text: "Our team greets you at Bagdogra Airport and drives you to Phuentsholing, Bhutan's bustling border town. Past Hashimara, the first Himalayan foothills appear — and we handle your Bhutan entry permit so you cross into the kingdom without delay.",
    tags: ["Airport pickup", "Permit formalities", "Dinner included"],
  },
  {
    n: "02",
    title: "Phuentsholing to Thimphu",
    kicker: "The Enchanting Capital",
    text: "After breakfast and immigration formalities, one of the most scenic drives of the trip: Kharbandi Gompa monastery with panoramic valley views, and Chuzom Bridge where the Paro and Wangchu rivers meet. Lunch in Paro en route, then Thimphu's cafes, markets and nightlife by evening.",
    tags: ["Kharbandi Gompa", "Chuzom Bridge", "Thimphu nightlife"],
  },
  {
    n: "03",
    title: "Thimphu to Punakha",
    kicker: "Buddhas & 108 Stupas",
    text: "Morning with the 54-metre Buddha Dordenma and the interactive Simply Bhutan museum, a photo stop at the Tashichho Dzong viewpoint, then over Dochula Pass at 10,200 ft — 108 memorial stupas against snow-capped peaks. End the day on Bhutan's longest suspension bridge over the Mo Chu–Po Chu confluence.",
    tags: ["Buddha Dordenma", "Dochula Pass", "Suspension bridge"],
  },
  {
    n: "04",
    title: "Punakha to Paro",
    kicker: "The Fortress Day",
    text: "Explore Punakha Dzong, Bhutan's most magnificent fortress-monastery at the meeting of two rivers. Then a scenic drive west to Paro with a lunch stop, and an evening browsing Paro Market's handicrafts, local delicacies and live music.",
    tags: ["Punakha Dzong", "Paro Market", "Scenic drive"],
  },
  {
    n: "05",
    title: "Tiger's Nest Monastery Hike",
    kicker: "The Signature Day",
    text: "The unforgettable moderate hike to Paro Taktsang at 3,120 m — the monastery clinging to a cliff edge, home to a sacred statue of Guru Rinpoche. Rest in the afternoon, then soothe your legs with an optional traditional hot stone bath in the evening.",
    tags: ["3,120 m cliff hike", "Hot stone bath (optional)", "Carry water & snacks"],
  },
  {
    n: "06",
    title: "Paro to Phuentsholing",
    kicker: "The Long Way Back",
    text: "Begin at the Paro Airport viewpoint for that famous valley panorama, stop at the historic Tamchog Zam iron bridge over the Paro Chhu, and pause again at the Chuzom confluence. Evening free in Phuentsholing's markets for souvenirs and handicrafts.",
    tags: ["Airport viewpoint", "Tamchog iron bridge", "Souvenir shopping"],
  },
  {
    n: "07",
    title: "Phuentsholing to Bagdogra",
    kicker: "Nadaselpey — Goodbye",
    text: "One last Bhutanese breakfast, then the transfer to Bagdogra Airport, arriving around 1:30–2:00 PM. Book any onward flight after 3:30 PM — and carry the Land of the Thunder Dragon home with you.",
    tags: ["Breakfast included", "Airport transfer", "Fly after 3:30 PM"],
  },
];

export const INCLUDED = [
  "6 nights in 3-star hotels across Phuentsholing, Thimphu, Punakha & Paro",
  "Bagdogra airport pickup & drop, all transfers",
  "Daily breakfast and dinner",
  "Bhutan visa, entry permit & SDF charges",
  "Experienced TrekPanda trip captain with first aid",
  "All sightseeing as per the itinerary",
];

export const EXCLUDED = [
  "Flights or trains to Bagdogra",
  "Entry tickets to monuments & museums",
  "Lunches and personal snacks",
  "Hot stone bath and personal expenses",
  "Travel insurance",
];
